<template>
  <div>
    <div class="container">
      <jumbotron />
      <user-articles />
      <new-articles />
      <articles-on-sales />
    </div>

    <highlihgted-categories />

    <div class="container">
      <home-banner />
    </div>

    <mobile-app />
    <top-brands />
  </div>
</template>

<script>
import UserArticles from './UserArticles.vue';
import NewArticles from './NewArticles.vue';
import Jumbotron from './Jumbotron.vue';
import HighlihgtedCategories from './HighlihgtedCategories.vue';
import ArticlesOnSales from './ArticlesOnSales.vue';
import HomeBanner from './HomeBanner.vue';
import TopBrands from './TopBrands.vue';
import MobileApp from './MobileApp.vue';

export default {
  name: 'Dashboard',
  components: {
    UserArticles,
    NewArticles,
    Jumbotron,
    HighlihgtedCategories,
    ArticlesOnSales,
    HomeBanner,
    TopBrands,
    MobileApp,
  },
  // mounted() {
  //   this.$store.dispatch('getAttributes', { retrieveAll: true });
  // },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  },
};
</script>
